import React from "react";
import { Tooltip } from "@fluentui/react-components";
import { Network } from "lucide-react";
import styles from "./OrgChartTriggerButton.module.scss";

const OrgChartTriggerButton = ({ onClick }) => (
  <Tooltip content="Org Chart" relationship="label">
    <button type="button" className={styles.orgChartTrigger} onClick={onClick}>
      <Network size={16} />
    </button>
  </Tooltip>
);

export default OrgChartTriggerButton;
